


export const all_routes = {
  //Auth routes
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  emailVerification: "/email-verification",
  twoStepVerification: "/two-step-verification",
  lockScreen: "/lock-screen",
  success: "/success",

  //Dashboard routes
  adminDashboard: "/index",
  adminDashboard2: "/admin-dashboard",


  //Customer Dashboard
  customerDashboard: "/customer/customer-dashboard",
  customerQuotation:"/customer/customer-quotations",
  customerInvoices:"/customer/customer-invoices",
  customerRecurringInvoices:"/customer/customer-recurring-invoices",
  customerTransactions:"/customer/customer-transactions",
  customerPaymentSummary:"/customer/customer-payment-summary",
  customerInvoiceReport:"/customer/customer-invoice-report",
  customerAccountSettings:"/customer/customer-account-settings",
  customerSecuritySettings:"/customer/customer-security-settings",
  customerPlansSettings:"/customer/customer-plans-settings",
  customerNotificationSettings:"/customer/customer-notification-settings",
  customerInvoiceDetails:"/customer/customer-invoice-details",


  //Super Admin routes
  superAdminDashboard: "/super-admin/super-admin-dashboard",
  companies: "/super-admin/companies",
  subscriptions: "/super-admin/subscriptions",
  packages: "/super-admin/packages",
  packagesGrid: "/super-admin/packages-grid",
  domain: "/super-admin/domain",
  purchaseTransaction: "/super-admin/purchase-transaction",

  //Application routes
  chat: "/application/chat",
  calendar: "/application/calendar",
  notes: "/application/notes",
  voiceCall: "/application/voice-call",
  videoCall: "/application/video-call",
  outgoingCall: "/application/outgoing-call",
  incomingCall: "/application/incoming-call",
  callHistory: "/application/call-history",
  todo: "/application/todo",
  todoList: "/application/todo-list",
  email: "/application/email",
  EmailReply: "/application/email-reply",
  audioCall: "/application/audio-call",
  fileManager: "/application/file-manager",
  socialFeed: "/application/social-feed",
  kanbanView: "/application/kanban-view",
  invoice: "/application/invoice",
  contacts: "/application/contacts",
  searchList: "/application/search-list",

  //Inventory and Sales
  products:"/products",
  addProduct:"/add-product",
  editProduct:"/edit-product",
  category:"/category",
  units:"/units",
  inventory:"/inventory",
  invoices:"/invoices",
  createInvoices:"/add-invoice",
  editInvoice:"/edit-invoice",
  invoiceDetails:"/invoice-details",
  invoiceTemplates:"/invoice-templates",
  recurringInvoices:"/recurring-invoices",
  creditNotes:"/credit-notes",
  addCreditNotes:"/add-credit-notes",
  editCreditNotes:"/edit-credit-notes",
  quotations:"/quotations",
  addquotations:"/add-quotation",
  editquotations:"/edit-quotation",
  deliveryChallans:"/delivery-challans",
  addDeliveryChallans:"/add-delivery-challan",
  editDeliveryChallans:"/edit-delivery-challan",
  customers:"/customers",
  addCustomer:"/add-customer",
  editCustomer:"/edit-customer",
  addInvoice:"/add-invoice",
  customerDetails:"/customer-details",
  notification:"/notifications",

  //Purchases routes
  purchases:"/purchases",
  addPurchase:"add-purchases",
  editPurchase:"edit-purchases",
  purchaseOrders:"/purchase-orders",
  addPurchaseOrders:"/add-purchases-orders",
  editPurchaseOrders:"/edit-purchases-orders",
  debitNotes:"/debit-notes",
  addDebitNotes:"/add-debit-notes",
  editDebitNotes:"/edit-debit-notes",
  suppliers:"/suppliers",
  suppliersPayments:"/supplier-payments",
  purchaseReport:"/purchases-report",
  
  //Finance & Accounts routes
  expenses:"/expenses",
  incomes:"/incomes",
  payments:"/payments",
  transactions:"/transactions",
  bankAccounts:"/bank-accounts",
  bankAccountsType:"/bank-accounts-type",
  moneyTransfer:"/money-transfer",

  //Manage
  users:"/users",
  rolesPermissions:"/roles-permissions",
  permission:"/permission",
  deleteAccountRequest:"/delete-account-request",
  membershipPlans:"/membership-plans",
  membershipAddons:"/membership-addons",
  subscribers:"/subscribers",
  membershipTransactions:"/membership-transactions",
  contactMessages:"/contact-messages",
  tickets:"/tickets",
  ticketsList:"/tickets-list",
  ticketKanban:"/ticket-kanban",
  ticketDetails:"/ticket-details",

  //Administration routes
  stockSummary:"/stock-summary",
  inventoryReport:"/inventory-report",
  bestSeller:"/best-seller",
  lowStock:"/low-stock",
  stockHistory:"/stock-history",
  soldStock:"/sold-stock",
  salesReport:"/sales-report",
  salesReturns:"/sales-returns",
  salesOrders:"/sales-orders",
  purchasesReport:"/purchases-report",
  purchaseReturnReport:"/purchase-return-report",
  purchaseOrdersReport:"/purchase-orders-report",
  quotationReport:"/quotation-report",
  paymentSummary:"/payment-summary",
  taxReport:"/tax-report",
  expenseReport:"/expense-report",
  incomeReport:"/income-report",
  profitLossReport:"/profit-loss-report",
  annualReport:"/annual-report",
  balanceSheet:"/balance-sheet",
  trialBalance:"/trial-balance",
  cashFlow:"/cash-flow",
  accountStatement:"/account-statement",
  customersReport:"/customers-report",
  customerDueReport:"/customers-due-report",
  supplierReport:"/supplier-report",
  
  //Settings routes
  accountSettings:"/general-settings/account-settings",
  securitySettings:"/general-settings/security-settings",
  plansBillings:"/general-settings/plans-billings",
  notificationsSettings:"/general-settings/notifications-settings",
  integrationsSettings:"/general-settings/integrations-settings",
  companySettings:"/website-settings/company-settings",
  localizationSettings:"/website-settings/localization-settings",
  prefixesSettings:"/website-settings/prefixes-settings",
  preferenceSettings:"/website-settings/preference-settings",
  seoSetup:"/website-settings/seo-setup",
  languageSettings:"/website-settings/language-settings",
  languageSettings2:"/website-settings/language-settings-2",
  languageSettings3:"/website-settings/language-settings-3",
  maintenanceMode:"/website-settings/maintenance-mode",
  authenticationSettings:"/website-settings/authentication-settings",
  aiConfiguration:"/website-settings/ai-configuration",
  appearanceSettings:"/website-settings/appearance-settings",
  pluginManager:"/website-settings/plugin-manager",
  invoiceSettings:"/app-settings/invoice-settings",
  invoiceTemplatesSettings:"/app-settings/invoice-templates-settings",
  esignatures:"/app-settings/esignatures",
  barcodeSettings:"/app-settings/barcode-settings",
  thermalPrinter:"/app-settings/thermal-printer",
  customFields:"/app-settings/custom-fields",
  sassSettings:"/app-settings/sass-settings",
  emailSettings:"/system-settings/email-settings",
  emailTemplates:"/system-settings/email-templates",
  smsGateways:"/system-settings/sms-gateways",
  gdprCookies:"/system-settings/gdpr-cookies",
  paymentMethods:"/finance-settings/payment-methods",
  bankAccountsSettings:"/finance-settings/bank-accounts",
  taxRates:"/finance-settings/tax-rates",
  currencies:"/finance-settings/currencies",
  customCss:"/other-settings/custom-css",
  customJs:"/other-settings/custom-js",
  clearCache:"/other-settings/clear-cache",
  sitemap:"/other-settings/sitemap",
  storage:"/other-settings/storage",
  cronjob:"/other-settings/cronjob",
  systemBackup:"/other-settings/system-backup",
  databaseBackup:"/other-settings/database-backup",
  systemUpdate:"/other-settings/system-update",


  //Layout Page routes
  layoutDefault:"/layout-default",
  layoutSingle:"/layout-single",
  layoutMini:"/layout-mini",
  layoutTransparent:"/layout-transparent",
  layoutWithoutHeader:"/layout-without-header",
  layoutRtl:"/layout-rtl",
  layoutDark:"/layout-dark",

  //Content Page routes
  pages:"/pages",
  blogs:"/blogs",
  addBlogs:"/add-blog",
  editBlogs:"/edit-blog",
  blogDetails:"/blog-details",
  blogCategories:"/blog-categories",
  blogTags:"/blog-tags",
  blogComments:"/blog-comments",
  countries:"/countries",
  states:"/states",
  cities:"/cities",
  testimonials:"/testimonials",
  faq:"/faq",

  //Pages routes
  profile:"/profile",
  starter:"/starter",
  gallery:"/gallery",
  pricing:"/pricing",
  timeline:"/timeline",
  comingSoon:"/coming-soon",
  underMaintenance:"/under-maintenance",
  underConstruction:"/under-construction",
  error404:"/error-404",
  error500:"/error-500",
  apiKeys:"/api-keys",
  privacyPolicy:"/privacy-policy",
  termsCondition:"/terms-condition",

  generalInvoice1: "/general-invoice-1",
  generalInvoice2: "/general-invoice-2",
  generalInvoice3: "/general-invoice-3",
  generalInvoice4: "/general-invoice-4",
  generalInvoice5: "/general-invoice-5",
  generalInvoice6: "/general-invoice-6",
  generalInvoice7: "/general-invoice-7",
  generalInvoice8: "/general-invoice-8",
  generalInvoice9: "/general-invoice-9",
  generalInvoice10: "/general-invoice-10",
  busBookingInvoice: "/bus-booking-invoice",
  carBookingInvoice: "/car-booking-invoice",
  coffeeShopInvoice: "/coffee-shop-invoice",
  domainHostingInvoice: "/domain-hosting-invoice",
  ecommerceInvoice: "/ecommerce-invoice",
  fitnessCenterInvoice: "/fitness-center-invoice",
  flightBookingInvoice: "/flight-booking-invoice",
  hotelBookingInvoice: "/hotel-booking-invoice",
  internetBillingInvoice: "/internet-billing-invoice",
  invoiceMedical: "/invoice-medical",
  moneyExchangeInvoice: "/money-exchange-invoice",
  movieTicketBookingInvoice: "/movie-ticket-booking-invoice",
  restaurantsInvoice: "/restaurants-invoice",
  studentBillingInvoice: "/student-billing-invoice",
  trainTicketInvoice: "/train-ticket-invoice",
  receiptInvoice1: "/receipt-invoice-1",
  receiptInvoice2: "/receipt-invoice-2",
  receiptInvoice3: "/receipt-invoice-3",
  receiptInvoice4: "/receipt-invoice-4",

  //Ui Imterface
  dragula:"/extended-dragula",
  uiAccordion: "/ui-accordion",
  uiAlerts: "/ui-alerts",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBreadcrumb: "/ui-breadcrumb",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiCollapse: "/ui-collapse",
  uiDropdowns: "/ui-dropdowns",
  uiRatio: "/ui-ratio",
  uiGrid: "/ui-grid",
  uiImages: "/ui-images",
  uiLinks: "/ui-links",
  uiListGroup: "/ui-list-group",
  uiModals: "/ui-modals",
  uiOffcanvas: "/ui-offcanvas",
  uiPagination: "/ui-pagination",
  uiPlaceholders: "/ui-placeholders",
  uiPopovers: "/ui-popovers",
  uiProgress: "/ui-progress",
  uiScrollspy: "/ui-scrollspy",
  uiSpinner: "/ui-spinner",
  uiNavTabs: "/ui-nav-tabs",
  uiToasts: "/ui-toasts",
  uiTooltips: "/ui-tooltips",
  uiTypography: "/ui-typography",
  uiUtilities: "/ui-utilities",


  uiClipboard: "/ui-clipboard",
  uiRangeslider: "/ui-rangeslider",
  uiLightbox: "/ui-lightbox",
  uiRating: "/ui-rating",
  uiCounter: "/ui-counter",
  uiScrollbar: "/ui-scrollbar",

  chartApex: "/chart-apex",
  chartJs: "/chart-js",

  mapsLeaflet: "/maps-leaflet",

  tablesBasic: "/tables-basic",
  dataTables: "/data-tables",

  iconFontawesome: "/icon-fontawesome",
  iconTabler: "/icon-tabler",
  iconBootstrap: "/icon-bootstrap",
  iconRemix: "/icon-remix",
  iconIonic: "/icon-ionic",
  iconMaterial: "/icon-material",
  iconPe7: "/icon-pe7",
  iconThemify: "/icon-themify",
  iconWeather: "/icon-weather",
  iconTypicon: "/icon-typicon",
  iconFlag: "/icon-flag",
  
  formBasicInputs: "/form-basic-inputs",
  formCheckboxRadios: "/form-checkbox-radios",
  formInputGroups: "/form-input-groups",
  formGridGutters: "/form-grid-gutters",
  formFileupload: "/form-fileupload",
  formHorizontal: "/form-horizontal",
  formVertical: "/form-vertical",
  formFloatingLabels: "/form-floating-labels",
  formValidation: "/form-validation",
  formSelect2: "/form-select2",
  formPickers:"/form-pickers",
  formWizard:"/form-wizard",
  formMask:"/form-mask",
  
  //New Module
  branch:"/branch",
  stockTransfer:"/stock-transfer",
  shiftandschedule:"/shift-and-schedule",
  subscriber:"/subscriber",
  rewardpoints:"/reward-points",
  rewardPointsDetails:"/reward-points-details",
  shipment:"/shipment",
  shipmentDetails:"/shipment-details",
  requisitionManagement:"/requisition-management"
};
